import React, { useState, useEffect, useRef, useMemo } from "react";
import { Line, Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  BarElement,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  BarElement,
  ArcElement
);

const ChartDetail = ({ performancePieChartData, count }) => {
  const total = performancePieChartData.datasets[0].data.reduce(
    (a, b) => a + b,
    0
  );
  const [totalData, setTotalData] = useState(0);
  const [chartKey, setChartKey] = useState(0);
  console.log("performancePieChartData", total);
  const data = useMemo(
    () => performancePieChartData,
    [performancePieChartData, count]
  );
  const options = useMemo(
    () => ({
      rotation: -90,
      circumference: 180,
      maintainAspectRatio: false,
      cutout: "63%",
    }),
    []
  );
  const plugins = useMemo(
    () => [
      {
        id: "text",
        beforeDraw: function (chart, a, b) {
          var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;

          ctx.restore();
          var fontSize = (height / 150).toFixed(2);
          ctx.font = fontSize + "em sans-serif";
          ctx.textBaseline = "middle";

          var text = "Total",
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 1.5;
          let textValY = height / 1.2;

          ctx.fillText(text, textX, textY);
          ctx.fillText(count, textX, textValY);
          ctx.save();
        },
      },
    ],
    [count,performancePieChartData]
  );

  useEffect(() => {
    setTotalData(total);
  }, [performancePieChartData]);

  useEffect(() => {
    setChartKey(prev => prev + 1);
  }, [count]);

  return (
    <>
      {performancePieChartData ? (
        <Doughnut
          key={chartKey}
          data={data}
          // width={"100%"}
          // borderWidth={3}
          width={"275"}
          options={options}
          plugins={plugins}
        />
      ) : null}
    </>
  );
};

export default ChartDetail;
